<template>
  <div id="app">
    <el-container class="ReLogCont">
      <el-header>
        <div class="header-area">
        </div>
      </el-header>
      <el-container>
        <el-main>
          <div class="header-inner-area">
            <ul>
              <li>
                <img class="logo" src="../../assets/image/logo-new.png" alt="LOGO" />
              </li>
            </ul>
          </div>
          <el-divider class="header-divider"></el-divider>
        </el-main>
      </el-container>
      <div v-show="isShowing">
        <el-alert title="ユーザー管理者のメッセージ" class="adminAlertToaster"></el-alert>
        <el-alert title="障害が発生しています" class="alertToast" :closable="false"></el-alert>
      </div>
    </el-container>
    <div class="SID0018__ReloginCondition">
      <el-container>
        <div class="re-login-div">
          <div class="re-login" v-if="logoutdataSection == '1'">
            <el-row :gutter="20">
              <el-col :span="12" class="grid_top">
                <div class="grid-content">
                  <div class="re-login-h6">
                    <span>ログアウトが完了しました。</span>
                  </div>
                </div>
                <el-button @click="redirectTo0001" type="primary" plain>再ログイン</el-button>
              </el-col>
            </el-row>
          </div>
          <div class="re-login-1" v-else>
            <el-row :gutter="20">
              <el-col :span="24">
                <div class="grid-content">
                  <div class="re-login-h6">
                    <span>長時間操作されなかったため、自動的にログアウトされました。</span>
                  </div>
                </div>
                <el-button @click="redirectTo0001" type="primary" plain>再ログイン</el-button>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-container>
    </div>
    <el-container class="footer-div">
        <el-footer class="footer0018 footer-element">
          <FooterComponent />
          </el-footer>
      </el-container>
  </div>
</template>
<script>
import router from '../../router';
import FooterComponent from "../common/footerComponent.vue";
import Common from '../../common/CommonFunc.js';
export default {
  name: "Logout",
  data() {
    return {
      headerarea: "新聞・雑誌、WEB、TVクリッピング、情報収集",
      notice: "お知らせ",
      logout: "ログアウト",
      isShowing: false,
      logoutdataSection:''
    };
  },
  components: {
    FooterComponent,
  },
  methods: {
    redirectTo0001() {
      this.$LogButtonEvent("0018","ReLogin");
			this.$LogMethodIN("0018","redirectTo0001");
      const IsIPUser = Common.General.GetLocalStorage('ip_authenicate_user')
      if(IsIPUser == true){
        router.push({ 
          name: '0001', 
          query: { ip: 1 }
        });
      }else{
        router.push({
          name: "0001"
        });
      }
      this.$LogMethodOut("0018","redirectTo0001");
    }
  },
  mounted(){
    if(this.$route.params.logoutid == "1"){
     this.logoutdataSection=1;
    }
    else if(this.$route.params.logoutid == "2"){
      this.logoutdataSection=0;
    }else{
      this.logoutdataSection=1;
    }
  },
  created(){
    //For the screen Title
    document.title = "記事閲覧";
  }
};
</script>
<style scoped>
@import "../../assets/css/style.css";
@import "0018.css";
</style>